import { useStore } from "@nanostores/preact"
import { useTranslation } from "components/signup/components/Translation"
import { profile } from "components/signup/services/store"
import css from "../style.module.scss"

export const WeatherSummary = () => {
  const t = useTranslation()
  const user = useStore(profile)

  // Check if we're on the hourly page by looking at the URL
  const isDay = window.location.pathname.includes("/six_day")
  const isLegacy12day = user.legacy12day

  if (isDay && !isLegacy12day) {
    return (
      <div className={css["summary-container-day"]}>
        <h3 className={css["summary-title"]}>{t("summary_title")}</h3>
        <p className={css["summary-description"]}>{t("summary_description")}</p>
      </div>
    )
  }
  if (isDay && isLegacy12day) {
    return (
      <div className={css["summary-container-day"]}>
        <h3 className={css["summary-title"]}>{t("summary_title_12day")}</h3>
        <p className={css["summary-description"]}>{t("summary_description_12day")}</p>
      </div>
    )
  }
  return (
    <div className={css["summary-container-hour"]}>
      <h3 className={css["summary-title"]}>{t("summary_title_hourly")}</h3>
      <p className={css["summary-description"]}>{t("summary_description_hourly")}</p>
    </div>
  )
}
